import axios, { AxiosResponse } from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./getHeaderOptions";
import logger from "../utils/logger";

const API_ENDPOINT = API_URL + "api/v1";

export const getHeader = () => {
  return {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
};

export async function getIntegrations(): Promise<AxiosResponse<any, any>> {
  return await axios.get(`${API_ENDPOINT}/integration/user-integration`, {
    headers: getHeader(),
  });
}

// Add these to your existing services/integrations.tsx file

export async function checkGoogleTokenStatus(): Promise<AxiosResponse<any, any>> {
  logger.log("🔍 SERVICE: Checking Google token status...");
  const timestamp = new Date().getTime();
  return await axios.get(`${API_ENDPOINT}/user/google-token-and-status?${timestamp}`, {
    headers: {
      ...getHeader(),
      'Cache-Control': 'no-cache'
    },
  });
}

export async function getGoogleTokens(code: string): Promise<AxiosResponse<any, any>> {
  logger.log("🔐 SERVICE: Getting Google tokens...");
  return await axios.post(`${API_ENDPOINT}/user/get-google-tokens`, 
    { code }, 
    { headers: getHeader() }
  );
}

export async function disconnectGoogleScope(scope: string): Promise<AxiosResponse<any, any>> {
  logger.log("🔌 SERVICE: Disconnecting Google scope:", scope);
  return await axios.put(`${API_ENDPOINT}/integration/user-integration/google-disconnect`,
    { scope },
    { headers: getHeader() }
  );
}

export async function createIntegration(integrationData: any): Promise<AxiosResponse<any, any>> {
  logger.log("🔗 SERVICE: Creating integration:", integrationData);
  return await axios.post(`${API_ENDPOINT}/integration/user-integration`,
    integrationData,
    { headers: getHeader() }
  );
}

export async function deleteIntegration(integrationKey: string): Promise<AxiosResponse<any, any>> {
  logger.log("🗑️ SERVICE: Deleting integration:", integrationKey);
  return await axios.put(`${API_ENDPOINT}/integration/user-integration/${integrationKey}/disconnect`,
    {},
    { headers: getHeader() }
  );
}

export async function disconnectIntegration(integrationId: string): Promise<AxiosResponse<any, any>> {
  logger.log("🔌 SERVICE: Disconnecting integration:", integrationId);
  return await axios.put(`${API_ENDPOINT}/integration/user-integration/${integrationId}/disconnect`,
    {},
    { headers: getHeader() }
  );
}
